module.exports = __webpack_public_path__ + "img/import4.52234463.svg";